import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import {} from '../..';
import { useTheme } from '@emotion/react';
const useAlpha = (alpha) => {
    const theme = useTheme();
    const alphaValue = theme.contentAlpha[alpha ?? 'medium'];
    return `color-mix(in srgb, currentcolor, transparent ${Math.round((1 - alphaValue) * 100)}%) !important`;
};
const NoopText = ({ as, color: _color, alpha: _alpha, ...props }) => {
    const Component = as ?? 'span';
    return _jsx(Component, { ...props, css: { color: 'inherit' } });
};
const BaseText = ({ as, alpha = 'medium', ...props }) => {
    const theme = useTheme();
    const Component = as ?? 'span';
    return (_jsx(Component, { ...props, css: { color: theme.color.onBackground }, children: _jsx("span", { css: {
                display: 'contents',
                color: useAlpha(typeof alpha === 'function' ? alpha({ hover: false }) : alpha),
                ':hover': {
                    color: useAlpha(typeof alpha === 'function' ? alpha({ hover: true }) : alpha),
                },
            }, children: props['children'] }) }));
};
const decorateText = (typographyClass, element) => Object.assign(element, {
    A: (props) => (_jsx(BaseText, { as: "a", alpha: "high", ...props, css: theme => [
            typographyClass === undefined
                ? {}
                : typographyClass === 'noop'
                    ? { color: 'inherit', ':hover': { color: 'inherit' } }
                    : theme.typography[typographyClass],
            { textDecoration: 'underline' },
        ] })),
    Redacted: (props) => (_jsx(BaseText, { as: "del", alpha: "disabled", ...props, css: theme => [
            typographyClass === undefined || typographyClass === 'noop' ? {} : theme.typography[typographyClass],
            {
                color: 'transparent',
                borderRadius: theme.shape.extraSmall,
                background: 'radial-gradient(rgba(200, 200, 200, 0.1), rgba(0, 0, 0, 0.1))',
                filter: 'contrast(0.5) brightness(1.5)',
                ':hover': {
                    color: 'transparent',
                },
            },
        ] })),
});
const Text = Object.assign(BaseText, {
    H1: decorateText('h1', (props) => (_jsx(BaseText, { as: "h1", alpha: "high", ...props, css: useTheme().typography.h1 }))),
    H2: decorateText('h2', (props) => (_jsx(BaseText, { as: "h2", alpha: "high", ...props, css: useTheme().typography.h2 }))),
    H3: decorateText('h3', (props) => (_jsx(BaseText, { as: "h3", alpha: "high", ...props, css: useTheme().typography.h3 }))),
    H4: decorateText('h4', (props) => (_jsx(BaseText, { as: "h4", alpha: "high", ...props, css: useTheme().typography.h4 }))),
    BodyLarge: decorateText('bodyLarge', (props) => (_jsx(BaseText, { ...props, css: useTheme().typography.bodyLarge }))),
    Body: decorateText('body', (props) => (_jsx(BaseText, { ...props, css: useTheme().typography.body }))),
    BodySmall: decorateText('bodySmall', (props) => (_jsx(BaseText, { ...props, css: useTheme().typography.bodySmall }))),
    Noop: decorateText('noop', NoopText),
});
export default Text;
//# sourceMappingURL=Text.js.map